import type ITenantConfigRepository from '../ITenantConfigRepository';
import type { ConfigKey, TenantConfigDTO, UpdateTenantConfigDTO } from '../tenantConfig.types';
import { injectable } from 'inversify';
import API from '@repositories/Axios';

@injectable()
export class TenantConfigRepository implements ITenantConfigRepository {
  async getList(tenantId: string): Promise<TenantConfigDTO[]> {
    const result = await API.get<TenantConfigDTO[]>(`/api/v1/tenants/${tenantId}/configs`);
    return result.data;
  }
  async getDetail(tenantId: string, configKey: ConfigKey): Promise<string> {
    const result = await API.get<string>(`/api/v1/tenants/${tenantId}/configs/${configKey}`);
    return result.data;
  }
  async updateTenantConfig(data: UpdateTenantConfigDTO): Promise<TenantConfigDTO> {
    const result = await API.put<TenantConfigDTO>(`/api/v1/tenants/${data.tenantId}/configs/${data.configKey}`, data);
    return result.data;
  }
}
